module.exports = __webpack_public_path__ + "pc/img/body_basic 3.18e8aad7.jpg";